export interface IAlternativeName {
  id: number
  firstName: string
  middleName?: string
  lastName: string
  suffix?: string
  creditorName?: string
  accountNo?: string
  type?: string
}

export enum ResidenceType {
  Current = 0,
  Former = 1,
}

export interface IResidence {
  type: ResidenceType
  livingStatus: string
  noYears: string
  noMonths: string
  address: string
  monthlyRent: string
  landlordSection: string
  llName: string
  llAttn: string
  llAddress: string
  llPhone: string
  llFax: string
  notes: string
}

export interface IOtherIncomeRow {
  borrowerSeperator: string
  incomeType: string
  description: string
  amount: string
  selfEmployment: boolean
  frequency: string
  atrNotes: string
  otherNotes: string
}
